import React from 'react';

const AsyncTvAdsLibraryContainer = React.lazy(() => import('./ListContainer'));

export const TvAdsLibraryList = () => {
  return <AsyncTvAdsLibraryContainer />;
};
